<gbc-page-error-handler [content]="content" [pageError$]="pageError$"> </gbc-page-error-handler>
<ng-template #content>
  <gbc-page-header [pageInfo]="pageInfo">
    <ng-container gbc-page-header-right>
      @if (showCreateCompanyButton$ | async) {
        <button gbc-button [routerLink]="['/company/create']">
          {{ 'overview-page.create-company' | translate }}
        </button>
      }
      @if (showCreateUserButton$ | async) {
        <button gbc-button [routerLink]="['/users/create']">
          {{ 'overview-page.create-user' | translate }}
        </button>
      }
      @if (showCreateIgridSystemButton$ | async) {
        <button gbc-button [routerLink]="['/igrid/create']">
          {{ 'facility-page.create-installation' | translate }}
        </button>
      }
    </ng-container>
  </gbc-page-header>

  <gbc-tabs>
    <gbc-tab [title]="'overview-page.companies' | translate" name="companies">
      <gbc-page-container class="companies">
        <form [formGroup]="form">
          <app-searchbar formControlName="search" [placeholder]="'overview-page.search-company' | translate"></app-searchbar>
        </form>
        <gbc-tile [flexy]="true" [title]="'overview-page.companies' | translate">
          @if (companiesFilteredList$ | async; as companies) {
            <gbc-table [stickyHeaders]="true" clickableRows="true">
              <th gbc-table-header>{{ 'overview-page.name' | translate }}</th>
              @for (company of companies; track company) {
                <tr gbc-table-row [routerLink]="['/company/view', company.id]">
                  <td gbc-table-cell>{{ company.name }}</td>
                </tr>
              }
            </gbc-table>
          }
        </gbc-tile>
      </gbc-page-container>
    </gbc-tab>
    <gbc-tab [title]="'overview-page.users' | translate" name="users">
      <gbc-page-container>
        <app-users-list [users]="users$"></app-users-list>
      </gbc-page-container>
    </gbc-tab>

    <gbc-tab [title]="'overview-page.installations' | translate" name="installations">
      <gbc-page-container>
        <app-facility-installation-search-list></app-facility-installation-search-list>
      </gbc-page-container>
    </gbc-tab>
  </gbc-tabs>
</ng-template>
